module.exports = __webpack_public_path__ + "~@/assets/img/nanoLaw-1.102b5a29.png";